<template>
    <v-row>
        <v-col cols="12" class="section-title">
            {{ $t('common.implements') }}
        </v-col>
        <v-col cols="12" v-if="equipments.length === 0" class="no-equipments">
            {{ $t('common.no_implements') }}
        </v-col>
        <v-col cols="12" class="row px-5" v-else>
            <div v-for="equip in equipments" :key="equip.id" class="equipment-card">
                <v-img :src="equip.src" />
                {{ equip.name }}
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "EquipmentsProfile",
    props: {
        equipments: {
            type: Array,
            default: () => [],
        }
    }
}
</script>

<style scoped>

.section-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
}

.equipment-card {
    height: 81px;
    width: 60px;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    color: #333333;
    margin-bottom: 12px;
    margin-right: 4px;
}

.no-equipments {
    font-size: 14px;
    line-height: 17px;
    color: #333333;
    text-align: center;
}

</style>